import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "employers-page" };
const _hoisted_2 = { class: "employers-layout" };
const _hoisted_3 = { class: "employers-list-panel" };
const _hoisted_4 = { class: "search-box" };
const _hoisted_5 = { class: "employers-list" };
const _hoisted_6 = {
    key: 0,
    class: "employer-items"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_9 = { class: "employer-details-panel" };
const _hoisted_10 = {
    key: 0,
    class: "details-content"
};
const _hoisted_11 = { class: "detail-header" };
const _hoisted_12 = { class: "top-actions" };
const _hoisted_13 = { class: "form-row" };
const _hoisted_14 = { class: "form-group" };
const _hoisted_15 = { class: "form-group" };
const _hoisted_16 = { class: "form-group checkbox" };
const _hoisted_17 = { class: "form-group" };
const _hoisted_18 = { class: "licenses-section" };
const _hoisted_19 = { class: "license-row" };
const _hoisted_20 = { class: "license-info" };
const _hoisted_21 = {
    key: 0,
    class: "features-section"
};
const _hoisted_22 = {
    key: 0,
    class: "features-list"
};
const _hoisted_23 = { class: "feature-name" };
const _hoisted_24 = ["onClick"];
const _hoisted_25 = { class: "form-group" };
const _hoisted_26 = { class: "form-group" };
const _hoisted_27 = { class: "form-group" };
const _hoisted_28 = { class: "form-group" };
const _hoisted_29 = { class: "knowledge-base-files-section" };
const _hoisted_30 = { class: "form-group" };
const _hoisted_31 = { class: "file-upload-container" };
const _hoisted_32 = ["disabled"];
const _hoisted_33 = {
    key: 0,
    class: "file-info-container"
};
const _hoisted_34 = { class: "file-name" };
const _hoisted_35 = { class: "file-description-label" };
const _hoisted_36 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_37 = { class: "drawer-header" };
const _hoisted_38 = { class: "drawer-content" };
const _hoisted_39 = {
    key: 0,
    class: "loading"
};
const _hoisted_40 = {
    key: 1,
    class: "licenses-grid"
};
const _hoisted_41 = {
    key: 2,
    class: "empty"
};
const _hoisted_42 = { class: "modal-header" };
const _hoisted_43 = { class: "modal-body" };
const _hoisted_44 = { class: "modal-footer" };
const _hoisted_45 = { class: "modal-header" };
const _hoisted_46 = { class: "modal-footer" };
const _hoisted_47 = { class: "modal-header" };
const _hoisted_48 = { class: "modal-body" };
const _hoisted_49 = { class: "delete-confirm-group" };
const _hoisted_50 = { class: "checkbox-label" };
const _hoisted_51 = { class: "delete-confirm-group" };
const _hoisted_52 = { class: "confirm-hint" };
const _hoisted_53 = ["placeholder"];
const _hoisted_54 = { class: "modal-footer" };
const _hoisted_55 = ["disabled"];
const _hoisted_56 = { class: "modal-header" };
const _hoisted_57 = { class: "modal-body" };
const _hoisted_58 = { class: "employer-name-display" };
const _hoisted_59 = { class: "modal-footer" };
import { ref, computed, onMounted } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
import AdminTable from '@/admin/components/AdminTable.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EmployersPage',
    setup(__props) {
        const admin = useAdmin();
        const fileInput = ref(null);
        const selectedEmployer = ref(null);
        const editingData = ref({});
        const searchQuery = ref('');
        const showLicenses = ref(false);
        const showFeatures = ref(false);
        const showLicensesDrawer = ref(false);
        const freeLicenses = ref([]);
        const licensesLoading = ref(false);
        const showKeysConfirm = ref(false);
        const showRemoveKeysConfirm = ref(false);
        const keysToUpload = ref([]);
        const showSuccessToast = ref(false);
        const successMessage = ref('');
        const showErrorToast = ref(false);
        const errorMessage = ref('');
        const selectedFile = ref(null);
        const selectedFileDescription = ref('');
        const knowledgeBaseFiles = ref([]);
        const showDeleteConfirm = ref(false);
        const deleteConfirmText = ref('');
        const deleteAcknowledge = ref(false);
        const showFinalDeleteConfirm = ref(false);
        const filteredEmployers = computed(() => {
            if (!searchQuery.value.trim()) {
                return admin.adminState.employers;
            }
            const query = searchQuery.value.toLowerCase();
            return admin.adminState.employers.filter((emp) => emp.name.toLowerCase().includes(query));
        });
        const deleteConfirmValid = computed(() => {
            const expectedText = `DELETE ${selectedEmployer.value.id}`;
            return deleteConfirmText.value === expectedText;
        });
        const knowledgeBaseColumns = computed(() => {
            return [
                { field: 'fileName', label: 'File Name', width: '2fr', sortable: true },
                { field: 'description', label: 'Description', width: '3fr' },
                { field: 'createDateTime', label: 'Date Uploaded', width: '1.5fr', sortable: true, type: 'date' },
                { field: 'fileUri', label: 'File Link', width: '1fr' }
            ];
        });
        function showToast(message) {
            successMessage.value = message;
            showSuccessToast.value = true;
        }
        function showError(message) {
            errorMessage.value = message;
            showErrorToast.value = true;
        }
        function selectEmployer(employer) {
            selectedEmployer.value = employer;
            knowledgeBaseFiles.value = [];
            admin.getEmployerDetails(employer.id, (fullDetails) => {
                selectedEmployer.value = fullDetails;
                editingData.value = {
                    name: fullDetails.name,
                    logoUri: fullDetails.logoUri,
                    emailDomain: fullDetails.emailDomain,
                    goldFeeStructure: fullDetails.goldFeeStructure,
                    benefitsHeaderImageUrl: fullDetails.benefitsHeaderImageUrl,
                    benefitsDescription: fullDetails.benefitsDescription,
                    chatMGPrompt: fullDetails.chatMGPrompt,
                    availableLicenses: fullDetails.availableLicenses,
                    redeemedLicenses: fullDetails.redeemedLicenses,
                    keysText: ''
                };
                admin.getEmployerKnowledgeBaseFiles(selectedEmployer.value.id, (files) => {
                    knowledgeBaseFiles.value = files;
                });
            });
        }
        function saveEmployer() {
            const employerData = {
                name: editingData.value.name,
                logoUri: editingData.value.logoUri,
                emailDomain: editingData.value.emailDomain,
                goldFeeStructure: editingData.value.goldFeeStructure,
                benefitsHeaderImageUrl: editingData.value.benefitsHeaderImageUrl,
                benefitsDescription: editingData.value.benefitsDescription,
                chatMGPrompt: editingData.value.chatMGPrompt
            };
            if (!selectedEmployer.value.id) {
                admin.createEmployer(employerData, () => {
                    showToast('Employer created successfully');
                }, (error) => {
                    showError(error);
                });
            }
            else {
                const updateData = {
                    id: selectedEmployer.value.id,
                    ...employerData,
                    createDateTime: selectedEmployer.value.createDateTime,
                    features: selectedEmployer.value.features,
                    availableLicenses: selectedEmployer.value.availableLicenses,
                    redeemedLicenses: selectedEmployer.value.redeemedLicenses,
                    hashGatewayKeys: selectedEmployer.value.hashGatewayKeys
                };
                admin.updateEmployer(selectedEmployer.value.id, updateData, () => {
                    admin.getEmployers();
                    showToast('Employer updated successfully');
                }, (error) => {
                    showError(error);
                });
            }
        }
        function confirmUploadKeys() {
            const keys = editingData.value.keysText.split('\n').filter((key) => key.trim() !== '');
            if (keys.length === 0) {
                showToast('Please enter some keys to upload');
                return;
            }
            keysToUpload.value = keys;
            showKeysConfirm.value = true;
        }
        function uploadKeys() {
            admin.uploadKeys(selectedEmployer.value.id, keysToUpload.value, () => {
                showKeysConfirm.value = false;
                editingData.value.keysText = '';
                keysToUpload.value = [];
                showToast('Keys uploaded successfully');
            }, (error) => {
                showError(error);
            });
        }
        function confirmRemoveKeys() {
            showRemoveKeysConfirm.value = true;
        }
        function removeKeys() {
            admin.removeKeys(selectedEmployer.value.id, [], () => {
                showRemoveKeysConfirm.value = false;
                showToast('Keys removed successfully');
            }, (error) => {
                showError(error);
            });
        }
        function toggleShowLicenses() {
            showLicenses.value = !showLicenses.value;
        }
        function openFreeLicensesDrawer() {
            licensesLoading.value = true;
            freeLicenses.value = [];
            showLicensesDrawer.value = true;
            admin.getFreeLicenses(selectedEmployer.value.id, (licenses) => {
                freeLicenses.value = licenses;
                licensesLoading.value = false;
            });
        }
        function toggleFeature(feature) {
            feature.enabled = !feature.enabled;
            saveEmployer();
        }
        function handleFileSelect(event) {
            const file = event.target.files[0];
            if (file) {
                selectedFile.value = file;
                selectedFileDescription.value = '';
            }
        }
        function deleteKnowledgeBaseFile(file) {
            admin.deleteEmployerKnowledgeBaseFile(selectedEmployer.value.id, file.id, () => {
                showToast('File deleted from Knowledge Base successfully');
                admin.getEmployerKnowledgeBaseFiles(selectedEmployer.value.id, (files) => {
                    knowledgeBaseFiles.value = files;
                });
            });
        }
        function uploadFile() {
            if (!selectedFile.value) {
                showError('Please select a file');
                return;
            }
            const reader = new FileReader();
            reader.onload = (e) => {
                const dataUrl = e.target.result;
                const base64Content = dataUrl.split(',')[1];
                const payload = {
                    content: base64Content,
                    fileName: selectedFile.value.name,
                    description: selectedFileDescription.value
                };
                admin.uploadEmployerKnowledgeBase(selectedEmployer.value.id, payload, () => {
                    showToast('File uploaded to Knowledge Base successfully');
                    selectedFile.value = null;
                    selectedFileDescription.value = '';
                    fileInput.value.value = '';
                    admin.getEmployerKnowledgeBaseFiles(selectedEmployer.value.id, (files) => {
                        knowledgeBaseFiles.value = files;
                    });
                }, () => {
                    showError('Failed to upload file');
                });
            };
            reader.onerror = () => {
                showError('Error reading file');
            };
            reader.readAsDataURL(selectedFile.value);
        }
        function createNewEmployer() {
            const newEmployer = {
                id: '',
                name: '',
                logoUri: '',
                emailDomain: '',
                goldFeeStructure: false,
                benefitsHeaderImageUrl: '',
                benefitsDescription: '',
                chatMGPrompt: '',
                availableLicenses: 0,
                redeemedLicenses: 0,
                createDateTime: new Date().toISOString(),
                features: [],
                hashGatewayKeys: []
            };
            selectedEmployer.value = newEmployer;
            editingData.value = {
                name: '',
                logoUri: '',
                emailDomain: '',
                goldFeeStructure: false,
                benefitsHeaderImageUrl: '',
                benefitsDescription: '',
                chatMGPrompt: '',
                availableLicenses: 0,
                redeemedLicenses: 0,
                keysText: ''
            };
        }
        function proceedToFinalDeleteConfirm() {
            showDeleteConfirm.value = false;
            showFinalDeleteConfirm.value = true;
        }
        function confirmDeleteEmployer() {
            admin.deleteEmployer(selectedEmployer.value.id, () => {
                showFinalDeleteConfirm.value = false;
                deleteConfirmText.value = '';
                deleteAcknowledge.value = false;
                selectedEmployer.value = null;
                showToast('Employer deleted successfully');
            }, (error) => {
                showError(error);
            });
        }
        onMounted(() => {
            console.log('Employers Page loaded');
            admin.getEmployers();
        });
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_snackbar = _resolveComponent("v-snackbar");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _cache[37] || (_cache[37] = _createElementVNode("div", { class: "list-header" }, [
                            _createElementVNode("h2", null, "Employers")
                        ], -1)),
                        _createElementVNode("div", _hoisted_4, [
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                                type: "text",
                                placeholder: "Search employers...",
                                class: "search-input"
                            }, null, 512), [
                                [_vModelText, searchQuery.value]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            (filteredEmployers.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredEmployers.value, (employer) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: employer.id,
                                            class: _normalizeClass(["employer-item", { active: selectedEmployer.value && selectedEmployer.value.id === employer.id }]),
                                            onClick: ($event) => (selectEmployer(employer))
                                        }, _toDisplayString(employer.name), 11, _hoisted_7));
                                    }), 128))
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_8, " No employers found "))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                        (selectedEmployer.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, _toDisplayString(selectedEmployer.value.id || 'New Employer'), 1),
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("button", {
                                        class: "action-btn primary",
                                        onClick: saveEmployer
                                    }, _toDisplayString(selectedEmployer.value.id ? 'Save Changes' : 'Create Employer'), 1),
                                    _createElementVNode("button", {
                                        class: "action-btn secondary",
                                        onClick: createNewEmployer
                                    }, "New Employer"),
                                    (selectedEmployer.value.id)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "action-btn danger",
                                            onClick: _cache[1] || (_cache[1] = ($event) => (showDeleteConfirm.value = true))
                                        }, "Delete Employer"))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                        _cache[38] || (_cache[38] = _createElementVNode("label", null, "Name:", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((editingData.value.name) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, editingData.value.name]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_15, [
                                        _cache[39] || (_cache[39] = _createElementVNode("label", null, "Logo:", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((editingData.value.logoUri) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, editingData.value.logoUri]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("label", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((editingData.value.goldFeeStructure) = $event)),
                                                type: "checkbox",
                                                class: "form-checkbox"
                                            }, null, 512), [
                                                [_vModelCheckbox, editingData.value.goldFeeStructure]
                                            ]),
                                            _cache[40] || (_cache[40] = _createTextVNode(" Gold "))
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                    _cache[41] || (_cache[41] = _createElementVNode("label", null, "Email Whitelist(s):", -1)),
                                    _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((editingData.value.emailDomain) = $event)),
                                        class: "form-textarea",
                                        rows: "3"
                                    }, null, 512), [
                                        [_vModelText, editingData.value.emailDomain]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("div", _hoisted_20, [
                                            _createElementVNode("span", null, "Redeemed Licenses: " + _toDisplayString(editingData.value.redeemedLicenses || 0), 1),
                                            _createElementVNode("span", null, "Available Licenses: " + _toDisplayString(editingData.value.availableLicenses || 0), 1)
                                        ]),
                                        _createElementVNode("button", {
                                            class: "action-btn secondary",
                                            onClick: openFreeLicensesDrawer
                                        }, " Show / Hide ")
                                    ])
                                ]),
                                (selectedEmployer.value && selectedEmployer.value.features)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                        _createElementVNode("div", {
                                            class: "features-header",
                                            onClick: _cache[6] || (_cache[6] = ($event) => (showFeatures.value = !showFeatures.value))
                                        }, [
                                            _createElementVNode("h3", null, "Features (" + _toDisplayString(selectedEmployer.value.features.length) + ")", 1),
                                            _createElementVNode("span", {
                                                class: _normalizeClass(["expand-icon", { rotated: showFeatures.value }])
                                            }, "›", 2)
                                        ]),
                                        (showFeatures.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedEmployer.value.features, (feature) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: feature.id,
                                                        class: "feature-item"
                                                    }, [
                                                        _createElementVNode("div", _hoisted_23, _toDisplayString(feature.feature.name), 1),
                                                        _createElementVNode("button", {
                                                            class: _normalizeClass(["feature-status", { enabled: feature.enabled, disabled: !feature.enabled }]),
                                                            onClick: ($event) => (toggleFeature(feature))
                                                        }, _toDisplayString(feature.enabled ? 'Enabled' : 'Disabled'), 11, _hoisted_24)
                                                    ]));
                                                }), 128))
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_25, [
                                    _cache[42] || (_cache[42] = _createElementVNode("label", null, "Employee Benefits Img Url:", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((editingData.value.benefitsHeaderImageUrl) = $event)),
                                        type: "text",
                                        class: "form-input"
                                    }, null, 512), [
                                        [_vModelText, editingData.value.benefitsHeaderImageUrl]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_26, [
                                    _cache[43] || (_cache[43] = _createElementVNode("label", null, "Employee Benefits Description:", -1)),
                                    _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((editingData.value.benefitsDescription) = $event)),
                                        class: "form-textarea",
                                        rows: "4"
                                    }, null, 512), [
                                        [_vModelText, editingData.value.benefitsDescription]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_27, [
                                    _cache[44] || (_cache[44] = _createElementVNode("label", null, "Chat MG Context Info (the following info is about my employer.):", -1)),
                                    _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((editingData.value.chatMGPrompt) = $event)),
                                        class: "form-textarea",
                                        rows: "5"
                                    }, null, 512), [
                                        [_vModelText, editingData.value.chatMGPrompt]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                    _cache[45] || (_cache[45] = _createElementVNode("label", null, "Keys (one per line):", -1)),
                                    _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((editingData.value.keysText) = $event)),
                                        placeholder: "Paste keys here, one per line",
                                        class: "form-textarea",
                                        rows: "4"
                                    }, null, 512), [
                                        [_vModelText, editingData.value.keysText]
                                    ])
                                ]),
                                _createElementVNode("div", { class: "keys-actions" }, [
                                    _createElementVNode("button", {
                                        class: "action-btn primary",
                                        onClick: confirmUploadKeys
                                    }, "Upload Keys"),
                                    _createElementVNode("button", {
                                        class: "action-btn danger",
                                        onClick: confirmRemoveKeys
                                    }, "Remove Keys")
                                ]),
                                _createElementVNode("div", _hoisted_29, [
                                    _createVNode(AdminTable, {
                                        title: "Knowledge Base Files",
                                        icon: "📚",
                                        columns: knowledgeBaseColumns.value,
                                        data: knowledgeBaseFiles.value,
                                        loading: false,
                                        searchable: true,
                                        deletable: true,
                                        onRowDelete: deleteKnowledgeBaseFile,
                                        "empty-message": "No knowledge base files found."
                                    }, null, 8, ["columns", "data"])
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                    _cache[46] || (_cache[46] = _createElementVNode("label", null, "Knowledge Base File Upload", -1)),
                                    _createElementVNode("div", _hoisted_31, [
                                        _createElementVNode("input", {
                                            ref_key: "fileInput",
                                            ref: fileInput,
                                            type: "file",
                                            class: "form-input",
                                            onChange: handleFileSelect
                                        }, null, 544),
                                        (selectedFile.value)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "action-btn primary",
                                                disabled: !selectedFileDescription.value.trim(),
                                                onClick: uploadFile
                                            }, " Upload File ", 8, _hoisted_32))
                                            : _createCommentVNode("", true)
                                    ]),
                                    (selectedFile.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                            _createElementVNode("div", _hoisted_34, " Selected: " + _toDisplayString(selectedFile.value.name), 1),
                                            _createElementVNode("label", _hoisted_35, "\"The knowledge base contains a document with information about: " + _toDisplayString(selectedFileDescription.value) + "\"", 1),
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((selectedFileDescription).value = $event)),
                                                class: "form-textarea file-description-textarea",
                                                placeholder: "Enter a description for the file...",
                                                rows: "3"
                                            }, null, 512), [
                                                [_vModelText, selectedFileDescription.value]
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_36, " Select an employer to view details "))
                    ])
                ]),
                (showLicensesDrawer.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "drawer-overlay",
                        onClick: _cache[14] || (_cache[14] = ($event) => (showLicensesDrawer.value = false))
                    }, [
                        _createElementVNode("div", {
                            class: "drawer",
                            onClick: _cache[13] || (_cache[13] = _withModifiers(() => { }, ["stop"]))
                        }, [
                            _createElementVNode("div", _hoisted_37, [
                                _cache[47] || (_cache[47] = _createElementVNode("h3", null, "Free Licenses", -1)),
                                _createElementVNode("button", {
                                    class: "close-btn",
                                    onClick: _cache[12] || (_cache[12] = ($event) => (showLicensesDrawer.value = false))
                                }, "✕")
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                                (licensesLoading.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, "Loading licenses..."))
                                    : (freeLicenses.value.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(freeLicenses.value, (license, index) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: index,
                                                    class: "license-item"
                                                }, _toDisplayString(license), 1));
                                            }), 128))
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_41, "No free licenses available"))
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (showKeysConfirm.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "modal-overlay",
                        onClick: _cache[18] || (_cache[18] = ($event) => (showKeysConfirm.value = false))
                    }, [
                        _createElementVNode("div", {
                            class: "modal-dialog",
                            onClick: _cache[17] || (_cache[17] = _withModifiers(() => { }, ["stop"]))
                        }, [
                            _createElementVNode("div", _hoisted_42, [
                                _cache[48] || (_cache[48] = _createElementVNode("h3", null, "Confirm Upload", -1)),
                                _createElementVNode("button", {
                                    class: "close-btn",
                                    onClick: _cache[15] || (_cache[15] = ($event) => (showKeysConfirm.value = false))
                                }, "✕")
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("p", null, "Are you sure you want to upload " + _toDisplayString(keysToUpload.value.length) + " key(s)?", 1)
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                                _createElementVNode("button", {
                                    class: "action-btn primary",
                                    onClick: uploadKeys
                                }, "Upload"),
                                _createElementVNode("button", {
                                    class: "action-btn secondary",
                                    onClick: _cache[16] || (_cache[16] = ($event) => (showKeysConfirm.value = false))
                                }, "Cancel")
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (showRemoveKeysConfirm.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "modal-overlay",
                        onClick: _cache[22] || (_cache[22] = ($event) => (showRemoveKeysConfirm.value = false))
                    }, [
                        _createElementVNode("div", {
                            class: "modal-dialog",
                            onClick: _cache[21] || (_cache[21] = _withModifiers(() => { }, ["stop"]))
                        }, [
                            _createElementVNode("div", _hoisted_45, [
                                _cache[49] || (_cache[49] = _createElementVNode("h3", null, "Confirm Removal", -1)),
                                _createElementVNode("button", {
                                    class: "close-btn",
                                    onClick: _cache[19] || (_cache[19] = ($event) => (showRemoveKeysConfirm.value = false))
                                }, "✕")
                            ]),
                            _cache[50] || (_cache[50] = _createElementVNode("div", { class: "modal-body" }, [
                                _createElementVNode("p", null, "Are you sure you want to remove all keys? This action cannot be undone.")
                            ], -1)),
                            _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("button", {
                                    class: "action-btn danger",
                                    onClick: removeKeys
                                }, "Remove Keys"),
                                _createElementVNode("button", {
                                    class: "action-btn secondary",
                                    onClick: _cache[20] || (_cache[20] = ($event) => (showRemoveKeysConfirm.value = false))
                                }, "Cancel")
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (showDeleteConfirm.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 3,
                        class: "modal-overlay",
                        onClick: _cache[28] || (_cache[28] = ($event) => (showDeleteConfirm.value = false))
                    }, [
                        _createElementVNode("div", {
                            class: "modal-dialog delete-modal",
                            onClick: _cache[27] || (_cache[27] = _withModifiers(() => { }, ["stop"]))
                        }, [
                            _createElementVNode("div", _hoisted_47, [
                                _cache[51] || (_cache[51] = _createElementVNode("h3", null, "Delete Employer", -1)),
                                _createElementVNode("button", {
                                    class: "close-btn",
                                    onClick: _cache[23] || (_cache[23] = ($event) => (showDeleteConfirm.value = false))
                                }, "✕")
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                                _cache[55] || (_cache[55] = _createElementVNode("p", { class: "warning-text" }, " ⚠️ This action cannot be undone. All data associated with this employer will be permanently deleted. ", -1)),
                                _createElementVNode("div", _hoisted_49, [
                                    _createElementVNode("label", _hoisted_50, [
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((deleteAcknowledge).value = $event)),
                                            type: "checkbox",
                                            class: "form-checkbox"
                                        }, null, 512), [
                                            [_vModelCheckbox, deleteAcknowledge.value]
                                        ]),
                                        _cache[52] || (_cache[52] = _createTextVNode(" I understand the consequences of this action "))
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_51, [
                                    _cache[54] || (_cache[54] = _createElementVNode("label", null, "Type to confirm deletion:", -1)),
                                    _createElementVNode("div", _hoisted_52, [
                                        _cache[53] || (_cache[53] = _createTextVNode(" Type: ")),
                                        _createElementVNode("strong", null, "DELETE " + _toDisplayString(selectedEmployer.value.id), 1)
                                    ]),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((deleteConfirmText).value = $event)),
                                        type: "text",
                                        class: "form-input",
                                        placeholder: `DELETE ${selectedEmployer.value.id}`
                                    }, null, 8, _hoisted_53), [
                                        [_vModelText, deleteConfirmText.value]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("button", {
                                    class: "action-btn danger",
                                    disabled: !deleteAcknowledge.value || !deleteConfirmValid.value,
                                    onClick: proceedToFinalDeleteConfirm
                                }, " Proceed to Delete ", 8, _hoisted_55),
                                _createElementVNode("button", {
                                    class: "action-btn secondary",
                                    onClick: _cache[26] || (_cache[26] = ($event) => (showDeleteConfirm.value = false))
                                }, "Cancel")
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (showFinalDeleteConfirm.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 4,
                        class: "modal-overlay",
                        onClick: _cache[32] || (_cache[32] = ($event) => (showFinalDeleteConfirm.value = false))
                    }, [
                        _createElementVNode("div", {
                            class: "modal-dialog delete-modal",
                            onClick: _cache[31] || (_cache[31] = _withModifiers(() => { }, ["stop"]))
                        }, [
                            _createElementVNode("div", _hoisted_56, [
                                _cache[56] || (_cache[56] = _createElementVNode("h3", null, "Confirm Deletion", -1)),
                                _createElementVNode("button", {
                                    class: "close-btn",
                                    onClick: _cache[29] || (_cache[29] = ($event) => (showFinalDeleteConfirm.value = false))
                                }, "✕")
                            ]),
                            _createElementVNode("div", _hoisted_57, [
                                _cache[57] || (_cache[57] = _createElementVNode("p", { class: "final-warning-text" }, " ⚠️ You are about to permanently delete: ", -1)),
                                _createElementVNode("div", _hoisted_58, _toDisplayString(selectedEmployer.value.name), 1),
                                _cache[58] || (_cache[58] = _createElementVNode("p", { style: { "margin-top": "20px", "color": "var(--admin-text-secondary)", "font-size": "13px" } }, " This action cannot be undone. All associated data will be deleted permanently. ", -1))
                            ]),
                            _createElementVNode("div", _hoisted_59, [
                                _createElementVNode("button", {
                                    class: "action-btn danger",
                                    onClick: confirmDeleteEmployer
                                }, " Yes, Delete Permanently "),
                                _createElementVNode("button", {
                                    class: "action-btn secondary",
                                    onClick: _cache[30] || (_cache[30] = ($event) => (showFinalDeleteConfirm.value = false))
                                }, "Cancel")
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_component_v_snackbar, {
                    modelValue: showSuccessToast.value,
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event) => ((showSuccessToast).value = $event)),
                    timeout: 3000,
                    location: "bottom",
                    color: "success"
                }, {
                    actions: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                            icon: "mdi-close",
                            size: "small",
                            onClick: _cache[33] || (_cache[33] = ($event) => (showSuccessToast.value = false))
                        })
                    ]),
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(successMessage.value) + " ", 1)
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_snackbar, {
                    modelValue: showErrorToast.value,
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event) => ((showErrorToast).value = $event)),
                    timeout: 4000,
                    location: "bottom",
                    color: "error"
                }, {
                    actions: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                            icon: "mdi-close",
                            size: "small",
                            onClick: _cache[35] || (_cache[35] = ($event) => (showErrorToast.value = false))
                        })
                    ]),
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(errorMessage.value) + " ", 1)
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
